
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prikbord/[id]",
      function () {
        return require("private-next-pages/prikbord/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prikbord/[id]"])
      });
    }
  